export default "__VITE_ASSET__DJ4y34Sz__"